import {Injectable, Component, Injector} from "@angular/core";

class Engine {
  start() {
    return "engine starts!";
  }
}

@Injectable()
class Car {
  constructor(private engine: Engine) {
  }

  run() {
    return `${this.engine.start()} => car runs!`
  }
}

@Component({
  selector: 'core-injector',
  template: `
  <usecase-container title="Injector" src="core/injector">
    <usecase-content>
      <button (click)="text=car.run()">Click</button>
      <p>{{text}}</p>
    </usecase-content>
  </usecase-container>
  `,
  providers: [
    Engine,
    Car
  ]
})
export class InjectorComponent {
  private car: Car;
  private text = "";

  constructor(injector: Injector) {
    this.car = injector.get(Car);
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/injector/component.ts
 **/